export const VACANCIES_TITLE = "Vacatures";
export const VACANCIES_DESCRIPTION = "Kom jij ons team versterken? Bekijk onze openstaande vacatures.";

export function vacancyCountLabel(count: number) {
  return `${count} openstaande ${count === 1 ? "vacature" : "vacatures"}`;
}
